import request from "@/utils/request";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;
// debug auto deploy oversea on main

export function catSearch(param) {
  return request({
    url: `${BASE_API}/api/cat_search`,
    method: "get",
    params: param,
  });
}
export function getNav(param) {
  return request({
    url: `${BASE_API}/api/navigation`,
    method: "get",
    params: param,
  });
}
export function subCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "PUT",
    data,
  });
}
export function editCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "PATCH",
    data,
  });
}
export function getCustomAnalyse(param) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "get",
    params: param,
  });
}
export function deleteCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "DELETE",
    data,
  });
}
export function subCustomizable(data) {
  return request({
    url: `${BASE_API}/api/cem_customizable`,
    method: "PUT",
    data,
  });
}
export function editCustomizable(data) {
  return request({
    url: `${BASE_API}/api/cem_customizable`,
    method: "PATCH",
    data,
  });
}
export function getCustomizable(param) {
  return request({
    url: `${BASE_API}/api/cem_customizable`,
    method: "get",
    params: param,
  });
}
export function deleteCustomizable(data) {
  return request({
    url: `${BASE_API}/api/cem_customizable`,
    method: "DELETE",
    data,
  });
}
export function getCustomModelOptionData(param) {
  return request({
    url: `${BASE_API}/api/cem_user_model`,
    method: "get",
    params: param,
  });
}
